import { deleteAccount, requestExport } from "./endpoints/account.js";
import { ask, deleteAskThread, getAskThread, listAskThreads, recordAskOpen, renameAskThread, } from "./endpoints/ask.js";
import { openBillingPortal, startCheckout } from "./endpoints/billing.js";
import { createLinkCode, listLinkedChannels, unlinkChannel, } from "./endpoints/channels.js";
import { getHealth } from "./endpoints/health.js";
import { createMcpToken, listMcpTokens, revokeMcpToken, } from "./endpoints/mcp-tokens.js";
import { getMe } from "./endpoints/me.js";
import { createNook, deleteNook, getNook, listNooks, listNookSites, regenerateSummary, updateNook, } from "./endpoints/nooks.js";
import { search } from "./endpoints/search.js";
import { grantUatUser, grantUatUserById, listUatUsers, revokeUatUser, deleteUatUser, } from "./endpoints/uat.js";
import { getStorageUsage, signUpload } from "./endpoints/uploads.js";
import { createHttpClient } from "./http.js";
export class NookClient {
    #http;
    constructor(config) {
        this.#http = createHttpClient(config);
    }
    getHealth = () => getHealth(this.#http);
    getMe = () => getMe(this.#http);
    listNooks = (options) => listNooks(this.#http, options);
    listNookSites = () => listNookSites(this.#http);
    getNook = (id) => getNook(this.#http, id);
    createNook = (payload, idempotencyKey) => createNook(this.#http, payload, idempotencyKey);
    updateNook = (id, body) => updateNook(this.#http, id, body);
    deleteNook = (id) => deleteNook(this.#http, id);
    regenerateSummary = (id) => regenerateSummary(this.#http, id);
    signUpload = (body) => signUpload(this.#http, body);
    getStorageUsage = () => getStorageUsage(this.#http);
    search = (body, signal) => search(this.#http, body, signal);
    ask = (body, signal) => ask(this.#http, body, signal);
    getAskThread = (id) => getAskThread(this.#http, id);
    listAskThreads = (cursor) => listAskThreads(this.#http, cursor);
    deleteAskThread = (id) => deleteAskThread(this.#http, id);
    renameAskThread = (id, title) => renameAskThread(this.#http, id, title);
    listLinkedChannels = () => listLinkedChannels(this.#http);
    createLinkCode = () => createLinkCode(this.#http);
    unlinkChannel = (id) => unlinkChannel(this.#http, id);
    listMcpTokens = () => listMcpTokens(this.#http);
    createMcpToken = (name) => createMcpToken(this.#http, name);
    revokeMcpToken = (id) => revokeMcpToken(this.#http, id);
    recordAskOpen = (messageId, nookId) => recordAskOpen(this.#http, messageId, nookId);
    startCheckout = (plan) => startCheckout(this.#http, plan);
    openBillingPortal = () => openBillingPortal(this.#http);
    requestExport = () => requestExport(this.#http);
    deleteAccount = (body) => deleteAccount(this.#http, body);
    listUatUsers = () => listUatUsers(this.#http);
    grantUatUser = (body) => grantUatUser(this.#http, body);
    grantUatUserById = (id, body) => grantUatUserById(this.#http, id, body);
    revokeUatUser = (id) => revokeUatUser(this.#http, id);
    deleteUatUser = (id) => deleteUatUser(this.#http, id);
}
let instance = null;
/**
 * Configure the client for this runtime. Call once, at startup, before the
 * first render — each app's entry file is the only place this belongs.
 *
 * Returns the instance so a caller that wants it explicitly (a test, a
 * background script with no React at all) can hold onto it.
 */
export function createNookClient(config) {
    instance = new NookClient(config);
    return instance;
}
/**
 * Read the configured client. Throws rather than lazily constructing one,
 * because a missing `baseUrl` should fail at boot with this message and not as
 * a request to `undefined/health` somewhere in a component tree.
 */
export function getNookClient() {
    if (!instance) {
        throw new Error("createNookClient() must be called before any @nook/api-client hook is used.");
    }
    return instance;
}
/** Test seam: drops the configured instance. */
export function resetNookClient() {
    instance = null;
}
//# sourceMappingURL=client.js.map